
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqs5kEYxdn5x9J7vh0TBOvrXwCQBlQAd4GnoM9fbL57P64Meta } from "/var/www/cloud-website/pages/faqs.vue?macro=true";
import { default as indexkzCdKyBKY_I2EeUjNTRqk_P7ELP2jSuOdEjFB9fwz6sMeta } from "/var/www/cloud-website/pages/index.vue?macro=true";
import { default as contactox0ndfRI_45UJR_45Tvse1sQ2afQPHOpV_rn5FGTal0nZlowMeta } from "/var/www/cloud-website/pages/contacto.vue?macro=true";
import { default as privacy_45policyjKAVdtTe7aXinOlsG4YCDvPPHOtguXDawBm7K00cOJ0Meta } from "/var/www/cloud-website/pages/privacy-policy.vue?macro=true";
export default [
  {
    name: "faqs",
    path: "/faqs",
    component: () => import("/var/www/cloud-website/pages/faqs.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/cloud-website/pages/index.vue")
  },
  {
    name: "contacto",
    path: "/contacto",
    component: () => import("/var/www/cloud-website/pages/contacto.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/var/www/cloud-website/pages/privacy-policy.vue")
  }
]